// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__6bkRA","title":"Images45_title__1KZl6","images":"Images45_images__3amQ5"};